import React from "react";
// import logo from './logo.svg';
// import "./App.css";
import style from './App.module.scss';
// import './App.scss';
import { RouterProvider } from "react-router-dom";
// import {enqueueSnackbar} from 'notistack';
import { Router } from "./routes/route";

function App() {
  return (
    <div data-testid="app-element" className={style['plantrack-app']}>
      <RouterProvider router={Router} />
    </div>
  );
}

export default App;
